import React from "react";

interface OwnProps {
	children: any;
}
export const IconAndFormatTypeContainer = ({ children }: OwnProps) => {
	return <div className="flex align-items-center my-1">{children}</div>;
};
